'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _PopupPanel = require('../../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

var _BillingTierFree = require('./billingStatus/BillingTierFree');

var _BillingTierFree2 = _interopRequireDefault(_BillingTierFree);

var _Button = require('../../../../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _popupActions = require('../../../../components/popupPanel/popupActions');

var _popupOpenSelector = require('../../../../components/popupPanel/popupOpenSelector');

var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);

var _elementCountSelector = require('../../../../user/elementCount/elementCountSelector');

var _currentUserSelector = require('../../../../user/currentUserSelector');

var _userUtil = require('../../../../user/userUtil');

var _elementCountConstants = require('../../../../user/elementCount/elementCountConstants');

require('./BillingAlertPopup.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Only show the close button if not in the mobile view.
 */
var BillingAlertCloseButton = function BillingAlertCloseButton(_ref) {
    var isMobileView = _ref.isMobileView,
        closeAlertPopup = _ref.closeAlertPopup;

    if (isMobileView) return null;
    return _react2.default.createElement(
        'div',
        { className: 'header' },
        _react2.default.createElement(
            _Button2.default,
            { onClickFn: closeAlertPopup, className: 'close-button' },
            _react2.default.createElement(_Icon2.default, { name: 'close-x' })
        )
    );
};

BillingAlertCloseButton.propTypes = {
    closeAlertPopup: _propTypes2.default.func,
    isMobileView: _propTypes2.default.bool
};

var countSelector = (0, _reselect.createSelector)(_elementCountSelector.contentTotalCountSelector, _elementCountSelector.contentTotalLimitSelector, (0, _popupOpenSelector2.default)(_elementCountConstants.ELEMENT_COUNT_LIMIT_POPUP), _currentUserSelector.getCurrentUser, function (contentTotalCount, contentTotalLimit, popupOpen, currentUser) {
    return {
        contentTotalCount: contentTotalCount,
        contentTotalLimit: contentTotalLimit,
        popupOpen: popupOpen,
        currentUser: currentUser
    };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        openAlertPopup: function openAlertPopup() {
            return dispatch((0, _popupActions.openPopup)(_elementCountConstants.ELEMENT_COUNT_LIMIT_POPUP));
        },
        closeAlertPopup: function closeAlertPopup() {
            return dispatch((0, _popupActions.closePopup)(_elementCountConstants.ELEMENT_COUNT_LIMIT_POPUP));
        }
    };
};

var BillingAlertPopup = (_dec = (0, _reactRedux.connect)(countSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(BillingAlertPopup, _React$Component);

    function BillingAlertPopup() {
        _classCallCheck(this, BillingAlertPopup);

        return _possibleConstructorReturn(this, (BillingAlertPopup.__proto__ || Object.getPrototypeOf(BillingAlertPopup)).apply(this, arguments));
    }

    _createClass(BillingAlertPopup, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var oldCount = this.props.contentTotalCount;
            var contentTotalCount = nextProps.contentTotalCount,
                contentTotalLimit = nextProps.contentTotalLimit,
                openAlertPopup = nextProps.openAlertPopup,
                popupOpen = nextProps.popupOpen,
                currentUser = nextProps.currentUser;

            // don't open popup if currentUser is subscribed

            if ((0, _userUtil.isSubscribed)(currentUser)) return;

            // don't open popup if it's already open, or count went down
            if (popupOpen || contentTotalCount <= oldCount) return;

            // if you have too much content, open popup
            if (contentTotalCount >= contentTotalLimit - _elementCountConstants.ELEMENT_COUNT_WARNING_START && contentTotalCount % _elementCountConstants.ELEMENT_COUNT_WARNING_INTERVAL === 0) return openAlertPopup();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _PopupPanel2.default,
                _extends({}, this.props, {
                    popupId: _elementCountConstants.ELEMENT_COUNT_LIMIT_POPUP,
                    className: 'BillingAlertPopup',
                    stayOpen: true }),
                _react2.default.createElement(BillingAlertCloseButton, this.props),
                _react2.default.createElement(_BillingTierFree2.default, { buttonClass: 'FormButton primary' })
            );
        }
    }]);

    return BillingAlertPopup;
}(_react2.default.Component)) || _class);


BillingAlertPopup.propTypes = {
    contentTotalCount: _propTypes2.default.number,
    contentTotalLimit: _propTypes2.default.number,
    openAlertPopup: _propTypes2.default.func,
    closeAlertPopup: _propTypes2.default.func,
    currentUser: _propTypes2.default.object
};

exports.default = BillingAlertPopup;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/BillingAlertPopup.js
// module id = 772
// module chunks = 0